import React from "react";
import "./usSection.css";
import marisol from "../../assets/img/marisol.jpg";
import cele from "../../assets/img/cele.jpg";

export default function UsSection() {
  return (
    <section className="us-section">
      <div className="us-content">
        <div className="us-person">
          <img src={marisol} alt="Profesional 1" className="us-img" />
          <p className="us-text">
            On the other hand, we denounce with righteous indignation...
          </p>
        </div>

        <div className="us-person reverse">
          <img src={cele} alt="Profesional 2" className="us-img" />
          <p className="us-text">
            On the other hand, we denounce with righteous indignation...
          </p>
        </div>
      </div>
    </section>
  );
}
